export default __webpack_public_path__ + "static/media/a011-PPII-4.892d2fa5.svg";